export const yearData = {
    "chart": {
        "type": "LogMSLine",
        // "caption": "Loan Disbursment vs Repayment",
        // "subCaption": "Yearly (2018 - 2020)",
        "xAxisName": "Year",
        "yAxisName": "Amount(Million TZS)",
        "base": "10",
        // "numbersuffix": "M",
        // "theme": "fusion",
        "palettecolors": "5d62b5,29c3be,f2726f",
        "usePlotGradientColor": "0"
    },
    "categories": [
        {
            "category": [
                {
                    "label": "2018"
                },
                {
                    "label": "2019"
                },
                {
                    "label": "2020"
                }
            ]
        }
    ],
    "dataset": [
        {
            "seriesname": "Disbursment",
            "data": [
                {
                    "value": "126734"
                },
                {
                    "value": "159851"
                },
                {
                    "value": "1297393"
                }
            ]
        },
        {
            "seriesname": "Repayment",
            "data": [
                {
                    "value": "26059"
                },
                {
                    "value": "1292145"
                },
                {
                    "value": "236849"
                }
            ]
        }
    ]
}

export const monthData = {
    "chart": {
        "type": "LogMSLine",
        // "caption": "Loan Disbursment vs Repayment",
        // "subCaption": "So far this year",
        "xAxisName": "Month",
        "yAxisName": "Amount(Million TZS)",
        "base": "10",
        // "numbersuffix": "M",
        "theme": "fusion",
        "palettecolors": "5d62b5,29c3be,f2726f",
        "usePlotGradientColor": "0"
    },
    "categories": [
        {
            "category": [
                {
                    label: "Jan"
                },
                {
                    label: "Feb"
                },
                {
                    label: "Mar"
                },
                {
                    label: "Apr"
                },
                {
                    label: "May"
                },
                {
                    label: "Jun"
                },
                {
                    label: "Jul"
                },
                {
                    label: "Aug"
                },
                {
                    label: "Sep"
                },
                {
                    label: "Oct"
                },
                {
                    label: "Nov"
                },
                {
                    label: "Dec"
                }
            ]
       }
    ],
    "dataset": [
        {
            "seriesname": "Disbursment",
            "data": [
                {
                    value: "280"
                  },
                  {
                    value: "440"
                  },
                  {
                    value: "130"
                  },
                  {
                    value: "90"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                }
            ]
        },
        {
            "seriesname": "Repayment",
            "data": [
                {
                    value: "70"
                  },
                  {
                    value: "55"
                  },
                  {
                    value: "325"
                  },
                  {
                    value: "60"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                  },
                  {
                    // value: "0"
                }
            ]
        }
    ]
}
